import React, { useState } from "react";
import { Dropdown } from "react-bootstrap";
import Skeleton from "react-loading-skeleton";

const SelectTag = ({ label, options, value, onChange, name }) => {
  const [selectedOption, setSelectedOption] = useState(value || "");

  const handleSelect = (option) => {
    setSelectedOption(option);
    onChange({ target: { name, value: option?.value } });
  };

  return (
    <Dropdown>
      <Dropdown.Toggle
        variant="white"
        id={`dropdown-${name}`}
        className="category-dropdown-button"
      >
        {selectedOption ? selectedOption.label : label}
      </Dropdown.Toggle>

      <Dropdown.Menu>
        {options ? (
          options?.map((option) => (
            <Dropdown.Item
              key={option?.value}
              onClick={() => handleSelect(option)}
            >
              {option?.label}
            </Dropdown.Item>
          ))
        ) : (
          <>
            <Dropdown.Item>
              <Skeleton width={100} height={20} />
            </Dropdown.Item>
            <Dropdown.Item>
              <Skeleton width={100} height={20} />
            </Dropdown.Item>
            <Dropdown.Item>
              <Skeleton width={100} height={20} />
            </Dropdown.Item>
          </>
        )}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default SelectTag;
